import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getCalendarOwnerFromItem from './getCalendarOwnerFromItem';

/**
 * Creates an attendee with the email address of the group calendar from the event
 */
export default function getGroupAsAttendee(event: CalendarEvent): AttendeeType {
    return { Mailbox: getCalendarOwnerFromItem(event) };
}
